import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import * as actions from './projectsActions';
import { type ProjectsStore, mkProjectsStore } from './projectsTypes';

const reducer = handleActions<
  ProjectsStore,
  | ReturnType<typeof actions.getProjectSuccess>
  | ReturnType<typeof actions.createProjectSuccess>
  | ReturnType<typeof actions.createProject>
  | ReturnType<typeof actions.updateProject>
  | ReturnType<typeof actions.updateProjectSuccess>
  | ReturnType<typeof actions.deleteProject>
  | ReturnType<typeof actions.deleteProjectSuccess>
>(
  {
    [actions.getProjectSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),

    [actions.createProject.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.createProjectSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),

    [actions.updateProject.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.updateProjectSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),

    [actions.deleteProject.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.deleteProjectSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
  },
  mkProjectsStore(),
);

export default reducer;
